import { Container } from 'components/container'
import styled from 'styled-components/macro'
import { mq } from 'styles/mq'

export const HeroVideo = styled.video`
  display: block;
  width: 100%;
  object-fit: cover;
  opacity: 0.5;
  aspect-ratio: 1;
  margin-bottom: -30vw;
  -webkit-mask: linear-gradient(to bottom, black 75%, transparent);
  mask: linear-gradient(to bottom, black 75%, transparent);

  ${mq.medium} {
    position: absolute;
    aspect-ratio: 16 / 9;
    max-height: 100%;
    margin-bottom: 0;
  }
`

export const Header = styled.header`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 100%;
  max-height: 100vh;
  aspect-ratio: 16 / 9;

  &::before,
  &::after {
    content: '';
    display: block;
    flex: 1;
  }

  &::before {
    flex: 10;
  }

  ${Container} {
    position: relative;

    ${mq.large} {
      > div {
        max-width: calc(var(--gap-size) * 5 + var(--grid-size) * 6);
      }
    }

    ${mq.extraLarge} {
      > div {
        max-width: calc(50% - (var(--gap-size) / 2));
      }
    }
  }
`

export const List = styled.ul`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: var(--gap-size);
  list-style: none;
  padding: 0;
  margin: var(--gap-size) 0;

  ${mq.medium} {
    grid-template-columns: 1fr 1fr;
  }

  ${mq.large} {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
`

export const Episode = styled.li`
  position: relative;
  font-size: 1.5rem;
  font-weight: bold;
  text-transform: uppercase;

  button {
    all: unset;
    display: block;
    width: 100%;
    cursor: pointer;
  }

  &,
  figure {
    padding: 0;
    margin: 0;
  }

  figure {
    position: relative;

    &::before {
      content: '';
      display: block;
      aspect-ratio: 16 / 9;
      border: 1px solid rgba(255, 255, 255, 0.8);
    }
  }

  figcaption {
    margin-top: 0.5em;
  }

  img,
  video {
    display: block;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border: 1px solid rgba(255, 255, 255, 0.8);
    margin-bottom: 0.8em;
    aspect-ratio: 16 / 9;
    object-fit: cover;

    ${mq.smallOnly} {
      pointer-events: none;
    }
  }
`
